export default "__VITE_ASSET__BMQlDakb__"